import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import * as ApiUrl from "../../../constants/ApiUrl";
import "./style.css";
import {GET_USER_LICENSES} from "../../../constants/query/License.query";
import axios from "axios";
import {InitialUserLicenseDto, UserLicenseDto} from "../dto/UserLicense.dto";
import {LicenseType, LicenseTypeList} from "../constants/License.type";
import {PopupProps} from "../../common/popup/Popup.props";
import Popup from "../../common/popup/Popup";
import Edit from "../edit/Edit";
import leftArrow from "../../../assets/images/left-arrow.svg";

export default function Detail() {
    const location = useLocation();
    const navigate = useNavigate();

    const [userSeq, setUserSeq] = useState<number>(0);
    const [licenses, setLicenses] = useState<UserLicenseDto[]>([]);
    const [popupContent, setPopupContent] = useState<PopupProps | null>(null);
    const [editData, setEditData] = useState<UserLicenseDto | null>(null);

    useEffect(() => {
        if (location.state.seq) {
            setUserSeq(location.state.seq);
        }
    }, [location.state.seq]);

    useEffect(() => {
        if (userSeq) {
            getLicenses(userSeq);
        }
    }, [userSeq, editData]);

    const getLicenses = (seq: number) => {
        axios.post(ApiUrl.GRAPHQL, {query: GET_USER_LICENSES(seq)})
            .then(response => {
                const licenses = response.data.data.getUserLicenses.licenses;
                setLicenses(licenses);
            })
            .catch(error => console.log(error));
    }

    const handleUnsubscribeClick = (subscriptionSeq: number) => {
        setPopupContent({
            subject: "정기 결제 취소",
            message1: "정기 결제 취소를 하더라도 남은 기간동안 라이선스가 유지됩니다.",
            message2: "정기 결제를 취소하시겠습니까?",
            buttonName: "확인",
            onConfirm: () => unsubscribe(subscriptionSeq),
            useCloseButton: true,
            onClose: () => setPopupContent(null)
        });
    }

    const unsubscribe = (subscriptionSeq: number) => {
        axios.post(ApiUrl.UNSUBSCRIBE_LICENSE, {subscriptionSeq: subscriptionSeq})
            .then(() => {
                getLicenses(location.state.seq);
                setPopupContent(null);
            })
            .catch(error => console.log(error));
    }

    const handleEditClick = (license: UserLicenseDto) => {
        setEditData(license);
    }

    const handleAdminConfigClick = (licenseType: LicenseType) => {
        let tempLicenseDto: UserLicenseDto = {...InitialUserLicenseDto};
        tempLicenseDto.licenseCode = licenseType;
        setEditData(tempLicenseDto)
    }

    return (
        <>
            <main className="license-list-wrapper">
                <div className="license-list-body">
                    <div className="user-detail-title">
                        <div className="left">
                            <button className="arrow">
                                <img src={leftArrow} alt="arrow" onClick={() => navigate(-1)}/>
                            </button>
                            <div className="text">
                                {location.state.name} 님 라이선스 관리 상세
                            </div>
                        </div>
                    </div>
                    <div className="member-detail-license">
                        <div className="member-license-box">
                            <div className="license-box-title">
                                <div className="program">
                                    라이선스
                                </div>
                                <div className="license-number">
                                    상태
                                </div>
                                <div className="period">
                                    사용 기간
                                </div>
                            </div>
                            {
                                LicenseTypeList.map((licenseType, index) => {
                                    const subscribedLicense = licenses.find(license => license.licenseCode === licenseType.type);

                                    return (
                                        <div className="license-box-contents" key={index} data-testid="licenseItem">
                                            <div className="program">
                                                <img src={licenseType.icon} alt="icon"/>
                                                <div className="text" data-testid="licenseName">
                                                    {licenseType.name}
                                                </div>
                                            </div>
                                            <div className="license-status">
                                                {
                                                    subscribedLicense
                                                        ? "구독 중"
                                                        : "-"
                                                }
                                                {
                                                    subscribedLicense?.isSubscribing === false && (
                                                        <div className="canceled">
                                                            {"(정기결제 취소)"}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="period" data-testid="licenseState">
                                                {
                                                    licenseType.isFree
                                                        ? "무제한"
                                                        : (
                                                            subscribedLicense?.startAt
                                                                ? subscribedLicense?.startAt.replace("T", " ") + " ~ " + subscribedLicense?.nextRenewalAt.replace("T", " ")
                                                                : "-"
                                                        )
                                                }
                                            </div>
                                            {
                                                !licenseType.isFree && (
                                                    <div className="btn">
                                                        {
                                                            subscribedLicense != undefined ? (
                                                                <>
                                                                    {
                                                                        subscribedLicense.isSubscribing && (
                                                                            <button className="detail-btn" onClick={() => handleUnsubscribeClick(subscribedLicense?.subscriptionSeq)}>
                                                                                정기 결제 취소
                                                                            </button>
                                                                        )
                                                                    }
                                                                    <button className="buy-license-btn" onClick={() => handleEditClick(subscribedLicense)}>
                                                                        수정
                                                                    </button>
                                                                </>
                                                            ): (
                                                                <button className="buy-license-btn" onClick={() => handleAdminConfigClick(licenseType.type)}>
                                                                    라이선스 설정
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </main>
            {
                popupContent && <Popup data={popupContent} isLong={true}></Popup>
            }
            {
                editData && <Edit userSeq={userSeq} email={location.state.email} license={editData} setLicense={setEditData}/>
            }
        </>
    );
}